enum GeneralLedgerStatus {
  PENDING = 'PENDING',
  ARCH = 'ARCH',
  RESTATEMENT = 'RESTATEMENT',
}

const getGeneralLedgerStatusTitle = (type: string) => {
  let typeName;

  switch (type) {
    case GeneralLedgerStatus.ARCH:
      typeName = 'ARCH';
      break;
    case GeneralLedgerStatus.PENDING:
      typeName = 'Pending';
      break;
    case GeneralLedgerStatus.RESTATEMENT:
      typeName = 'Restatement';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};

export default getGeneralLedgerStatusTitle;
